import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { getIdFromUrlPath } from '@shared/helpers';
import { submitAdapter } from '@widgets/OrdersRecognition/lib';
import { useIsUploadingStatus } from '@widgets/OrdersRecognition/lib/hooks/useIsUploadingStatus';

type TUploadOrderCb<TResponse> = (formData: FormData) => Promise<TResponse>;
export const useHandleUploadOrder = <TResponse>({
    uploadOrderCb,
    dataToUpload,
}: {
    uploadOrderCb: TUploadOrderCb<TResponse>;
    dataToUpload: {
        file: TAttachmentOnClient['file'];
        comment: string;
    };
}) => {
    const isUploadingFile = useIsUploadingStatus();
    const uploadOrderHandler = async () => {
        const estimateId = getIdFromUrlPath('estimate');
        const formData = submitAdapter({ ...dataToUpload, estimateId });
        try {
            await uploadOrderCb(formData);
        } catch (e) {
            console.error('upload error', e);
        }
    };

    return {
        isUploadingFile,
        uploadOrderHandler,
    };
};
